import { isServiceProduct } from "@/lib/isServiceProduct";

/** Primary pill row — matches ServiceCard footer badges. */
export function ListingTypePills({ product, className = "" }) {
  if (!isServiceProduct(product)) {
    if (product?.productType === "Downloadable") {
      return (
        <div className={`flex flex-wrap gap-1 ${className}`}>
          <span className="w-max rounded-full bg-primary px-2 py-0.5 text-[11px] text-white">
            Downloadable
          </span>
        </div>
      );
    }
    return null;
  }

  /** Service label lives on the image (ListingTypeCornerBadge) — footer is duration only. */
  const duration = product?.serviceDetails?.durationMinutes;
  if (!duration) return null;

  return (
    <div className={`flex flex-wrap gap-1 ${className}`}>
      <span className="w-max rounded-full bg-[#a0e193] px-2 py-0.5 text-[11px] text-blue-950">
        {duration} min
      </span>
    </div>
  );
}

/** Compact overlay on listing images (home / shop strips). */
export function ListingTypeCornerBadge({
  product,
  className = "absolute right-3 top-3 z-20",
}) {
  if (!isServiceProduct(product)) return null;
  return (
    <span
      className={`pointer-events-none rounded-full bg-primary px-2.5 py-1 text-[11px] font-semibold text-white shadow-md ring-2 ring-white/70 ${className}`}
    >
      Service
    </span>
  );
}

export function listingCardCtaLabel(product) {
  return isServiceProduct(product) ? "View service" : "Shop now";
}
